export default {
  title: 'Loyaliteitsprogramma',
};
